import { fetchAuthSaga } from "./init/sagas";
import { rootSagas } from "./rootSagas";
import { all } from "redux-saga/effects";

type SagaEffect = Generator<unknown, unknown, unknown>;

function buildRootSaga(
  appSagas: SagaEffect[] = [],
  pageSagas: SagaEffect[] = [],
) {
  function* rootSaga() {
    yield all([
      ...rootSagas,
      ...appSagas,
      ...pageSagas,
      fetchAuthSaga(), // NOTE: Keep last as it triggers auth loading
    ]);
  }

  return rootSaga;
}

export type { SagaEffect };
export { buildRootSaga };
